import React, {Component} from "react";
import BreadcrumbItem from "../BreadcrumbItem/BreadcrumbItem";
import "./Page.css"
import {TitlePage} from "./Title";
import Loading from "../Loading/Loading";

class Page extends Component {

  render() {
    const {title, children, isLoading = false, smallName, breadcrumbs, noBreadcrumbs, sectionClassName = '', headerCustom} = this.props;
    let _breadcrumbs = [];
    _breadcrumbs.push(<BreadcrumbItem key={0} title="Início" to="/"
                                      icon="fa-dashboard"/>);
    if (breadcrumbs) {
      breadcrumbs.forEach((item) => {
        _breadcrumbs.push(item);
      });
    }

    return ([
      <section key={1} className="content-header">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            {!noBreadcrumbs && _breadcrumbs.map((item) => {
              return item;
            })}
          </ol>
        </nav>

        {headerCustom ? headerCustom : <TitlePage smallName={smallName} title={title}/>}
      </section>,
      <section key={2} style={{marginBottom: '5vh'}} className={"content " + sectionClassName}>
        {isLoading ? <Loading/> : children}
      </section>
    ]);
  }

}

export default Page;



// WEBPACK FOOTER //
// ./src/component/Page/Page.js